import React from 'react';

const IconMap = () => {
	return (
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<mask id="mask0_1263_8619" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
				<rect width="16" height="16" fill="#D9D9D9"/>
			</mask>
			<g mask="url(#mask0_1263_8619)">
				<path d="M10 13.241L6.00005 12.041L3.68083 12.8012C3.45092 12.8773 3.23554 12.8472 3.03468 12.7109C2.83383 12.5745 2.7334 12.3748 2.7334 12.1115V4.4013C2.7334 4.23634 2.77977 4.08763 2.87252 3.95515C2.96525 3.82267 3.08084 3.73293 3.2193 3.68592L6.00005 2.759L10 3.959L12.3193 3.19875C12.5492 3.10046 12.7646 3.12183 12.9654 3.26285C13.1663 3.40387 13.2667 3.60387 13.2667 3.86285V11.6243C13.2667 11.7936 13.2199 11.9461 13.1263 12.082C13.0327 12.2179 12.909 12.3038 12.7551 12.3397L10 13.241ZM9.56673 12.2179V4.71795L6.43336 3.76923V11.2692L9.56673 12.2179ZM10.4334 12.1846L12.4 11.5333V4.06667L10.4334 4.71795V12.1846ZM3.60005 11.9333L5.56673 11.2692V3.80257L3.60005 4.46667V11.9333Z" fill="#545454"/>
			</g>
		</svg>

	);
};

export default IconMap;
